<template>
  <div class="static-content">
    <section class="static__first-screen">
      <div class="first-screen__container">
        <div class="first-screen__content">
          <h1>{{$t('landing.h1')}}</h1>
          <p>{{$t('landing.h1Cap')}}</p>
          <custom-button :animation="true" @click="() => handleNextStep(1, true)">
            {{$t('landing.startQuiz')}}
          </custom-button>
        </div>

        <div class="first-screen__iphone">
          <div class="iphone">
            <img :src="mediaBaseUrl + 'landing/benefits/iphone.png'" alt="">
          </div>

          <div class="benefits" :style="{left: -sliderLeft + 'px'}">
            <div v-for="benefit in benefits" :key="benefit" class="benefit">
              <img :src="mediaBaseUrl + benefit" alt="">
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="features" class="features">
      <div class="features__container">
        <div class="features__content">
          <header>
            <div class="caption">{{$t('landing.features.title')}}</div>
            <h2>{{$t('landing.features.caption')}}</h2>

            <div class="video">
              <video loop muted autoplay playsinline class="lazy">
                <source :data-src="mediaBaseUrl + 'landing/features.mp4'" type="video/mp4" />
              </video>
            </div>
          </header>

          <div class="features__list">
            <div v-for="feature in features" :key="feature.title" class="feature">
              <img :src="mediaBaseUrl + feature.image" alt="">

              <div class="feature__content">
                <h3>{{feature.title}}</h3>
                <p>{{feature.text}}</p>
              </div>
            </div>
          </div>

          <custom-button :animation="true" @click="() => handleNextStep(4, true)">
            {{$t('landing.startQuiz')}}
          </custom-button>
        </div>

        <div class="video">
          <video loop muted autoplay playsinline class="lazy">
            <source :data-src="mediaBaseUrl + 'landing/features.mp4'" type="video/mp4" />
          </video>
        </div>
      </div>
    </section>

    <section class="reviews__header">
      <div class="header__container">
        <header>
          <h2>{{$t('landing.reviews.headerTitle')}}</h2>

          <custom-button :animation="true" @click="() => handleNextStep(2)">
            {{$t('landing.startQuiz')}}
          </custom-button>
        </header>

        <div class="reviews__statistics">
          <div class="stat">
            <div class="stat__number">{{$t('landing.reviews.stats[0].val')}}</div>
            <div class="stat__name">{{$t('landing.reviews.stats[0].name')}}</div>
          </div>
          <div class="stat">
            <div class="stat__number">{{$t('landing.reviews.stats[1].val')}}</div>
            <div class="stat__name">{{$t('landing.reviews.stats[1].name')}}</div>
          </div>
          <div class="stat">
            <div class="stat__number">{{$t('landing.reviews.stats[2].val')}}</div>
            <div class="stat__name">{{$t('landing.reviews.stats[2].name')}}</div>
          </div>
        </div>
      </div>
    </section>

    <section id="reviews" class="reviews">
      <div class="reviews__container">
        <header>
          <div class="caption">{{$t('landing.reviews.title')}}</div>
          <h2>{{$t('landing.reviews.caption')}}</h2>
        </header>

        <reviews-list />
      </div>
    </section>

    <section class="pre-footer">
      <div class="pre-footer__container">
        <div class="pre-footer__content">
          <div class="rewards">
            <div class="reward">
              <img :src="mediaBaseUrl + 'landing/reward-bg.png'" alt="">
              <div class="reward__value">{{$t('landing.preFooter.rewards[0].val')}}</div>
              <div class="reward__name">{{$t('landing.preFooter.rewards[0].name')}}</div>
            </div>
            <div class="reward">
              <img :src="mediaBaseUrl + 'landing/reward-bg.png'" alt="">
              <div class="reward__value">
                <img :src="mediaBaseUrl + 'landing/apple.svg'" alt="apple">
              </div>
              <div class="reward__name">{{$t('landing.preFooter.rewards[1].name')}}</div>
            </div>
          </div>

          <header>
            <h2>{{$t('landing.preFooter.title')}}</h2>
            <p>{{$t('landing.preFooter.caption')}}</p>
          </header>

          <custom-button :animation="true" @click="() => handleNextStep(3)">
            {{$t('landing.startQuiz')}}
          </custom-button>
        </div>
      </div>
    </section>

    <section id="faq" class="faq">
      <div class="faq__container">
        <header>
          <p class="caption">{{$t('landing.faq.title')}}</p>
          <h2>{{$t('landing.faq.caption')}}</h2>
        </header>

        <landing-faq />
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Landing",

  inject: ["mediaBaseUrl"],

  data() {
    return {
      features: this.$t('landing.features.list'),
      benefits: [
        "landing/benefits/1.svg",
        "landing/benefits/2.png",
        "landing/benefits/3.svg",
        "landing/benefits/4.svg",
        "landing/benefits/5.png",
        "landing/benefits/6.svg",
      ],
      sliderLeft: -40,
      slideWidth: 318,
      sliderGap: 40,
      horizontalScrollEnabled: false,
      isPressed: false,
      startY: 0,
      intersectsScreens: [],
    }
  },

  watch: {
    intersectsScreens: {
      handler(val) {
        this.horizontalScrollEnabled = val.reduce((acc, el) => {
          return acc = acc && el.intersects;
        }, true);
      },
      deep: true,
    },
  },

  mounted() {
    const videos = document.getElementsByTagName('video');

    const lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {
          for (const source in video.target.children) {
            const videoSource = video.target.children[source];
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
              videoSource.src = videoSource.dataset.src;
            }
          }
          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });
    for (const video of videos) {
      lazyVideoObserver.observe(video);
    }

    const doc = document.getElementsByClassName("static-content")[0];
    doc.addEventListener('wheel', this.handleWheel);

    if("ontouchstart" in window){
      doc.addEventListener('touchstart', this.startMoving);
      doc.addEventListener('touchmove', this.moveSlider);
      doc.addEventListener('touchend', this.endMoving);
    }

    const screenObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        const screen = this.intersectsScreens.find(s => {
          return s.el === entry.target;
        });

        screen.intersects = entry.isIntersecting;
      });
    });

    const features = document.getElementById("features");
    const firstScreen = document.getElementsByClassName("first-screen__content")[0];
    screenObserver.observe(features);
    screenObserver.observe(firstScreen);
    this.intersectsScreens = [{ el: features, intersects: false, }, { el: firstScreen, intersects: false, }];

    window.addEventListener("resize", this.isMobile);
    this.isMobile();
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.isMobile);
  },

  computed: {
    tracker() {
      return this.$root.$children[0].$refs.tracker
    },
    sliderMaxLeft() {
      return (this.benefits.length - 1) * this.slideWidth + ((this.benefits.length - 2) * this.sliderGap);
    },
  },

  methods: {
    isMobile() {
      if (window.innerWidth > 700) {
        this.slideWidth = 318;
      } else {
        this.slideWidth = 270;
      }
    },
    startMoving(e) {
      this.isPressed = true;
      this.startY = e.touches[0].clientY;
    },
    moveSlider(e) {
      const touch = e.touches[0];
      const deltaY = touch.clientY - this.startY;
      this.startY = touch.clientY;

      if (this.sliderLeft >= this.sliderMaxLeft) {
        this.horizontalScrollEnabled = false;
      }

      if (!this.isPressed) return;

      if (this.horizontalScrollEnabled) {
        e.preventDefault();
        this.sliderLeft -= deltaY;
      }

      if (this.sliderLeft >= this.sliderMaxLeft) {
        this.sliderLeft = this.sliderMaxLeft;
      } else if (this.sliderLeft <= -this.sliderGap) {
        this.sliderLeft = -this.sliderGap;
      }
    },
    endMoving(e) {
      this.isPressed = false;
    },
    handleWheel(e) {
      if (this.sliderLeft >= this.sliderMaxLeft) {
        this.horizontalScrollEnabled = false;
        this.sliderLeft += e.deltaY;
      }

      if (this.sliderLeft <= 0 && e.deltaY < 0) {
        this.horizontalScrollEnabled = false;
      }

      if (this.horizontalScrollEnabled) {
        e.preventDefault();
        this.sliderLeft += e.deltaY;
      }

      if (this.sliderLeft >= this.sliderMaxLeft) {
        this.sliderLeft = this.sliderMaxLeft;
      } else if (this.sliderLeft <= -this.sliderGap) {
        this.sliderLeft = -this.sliderGap;
      }
    },
    videoLoaded(e) {
      e.target.play();
    },
    releaseVideo() {
      const videos = document.getElementsByTagName('video');
      for (const video of videos) {
        video.removeEventListener('loadeddata', this.videoLoaded);
        video.pause();
        video.src = "";
        video.remove();
      }
    },
    handleNextStep(eventBtnNumber, isMobile) {
      this.releaseVideo();
      if (isMobile) {
        this.tracker.report('User_click_start_quiz4_mobile');
      } else {
        this.tracker.report(`User_click_start_quiz${eventBtnNumber}`);
      }
      this.$router.push("/quiz");
    },
  },
}
</script>

<style scoped lang="sass">
@import "./styles/landing.module"
</style>
